class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super(...arguments);
    this.isLoaded2 = false;
  }
  connectedCallback() {
    this.loadProducts();
    this.carosel = this.querySelector("carosel-component");
  }
  getSearchQueryString = function () {
    const items = new Set(
      JSON.parse(localStorage.getItem("theme:recently-viewed-products") || "[]")
    );
    if (this.hasAttribute("exclude-id")) {
      items.delete(parseInt(this.getAttribute("exclude-id")));
    }
    if (items.size < 4) {
      return "";
    }
    return Array.from(items.values(), (item) => `id:${item}`)
      .slice(0, parseInt(this.getAttribute("products-count")))
      .join(" OR ");
  };
  loadProducts = async function () {
    if (this.isLoaded2) {
      return;
    }
    this.isLoaded2 = true;
    const section = this.closest(".shopify-section"),
      url = `${
        Shopify.routes.root
      }search?type=product&q=${this.getSearchQueryString()}&section_id=${extractSectionId(
        section
      )}`,
      response = await fetch(url, { priority: "low" });
    const tempDiv = new DOMParser().parseFromString(
        await response.text(),
        "text/html"
      ),
      recentlyViewedProductsElement = tempDiv.querySelector(
        "recently-viewed-products"
      );
    if (recentlyViewedProductsElement.childElementCount > 0) {
      this.replaceChildren(
        ...document.importNode(recentlyViewedProductsElement, true).childNodes
      );
    }
    this.carosel.swiper.update();
  };
}

if (!window.customElements.get("recently-viewed-products")) {
  window.customElements.define(
    "recently-viewed-products",
    RecentlyViewedProducts
  );
}
